import React, { useEffect, useState } from "react";
import { Button, Modal, Row, Col, Form, FloatingLabel, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { UsersService } from "../../services/Users";
import { RolesService } from "../../services/Roles";
import { TalukServices } from "../../services/Taluk";
import { PHCServices } from "../../services/Phcs";
import { AshaBlockServices } from "../../services/AshaBlocks";
import { DesignationsService } from "../../services/Designations";

import AlertModal from "../../components/AlertModal";
import styles from "../../styles/Modal.module.css";
import buttonStyles from "../../styles/Buttons.module.css";

function AddUsers(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [taluks, setTaluks] = useState([]);
  const [phcs, setPhcs] = useState([]);
  const [ashaBlocks, setAshaBlocks] = useState([]);
  const [selectedTaluk, setSelectedTaluk] = useState("");
  const [selectedPhc, setSelectedPhc] = useState("");
  const [selectedAshaBlock, setSelectedAshaBlock] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [users, setUsers] = useState({
    name: "",
    email: "",
    mobileNo: "",
    roleId: "",
    designationId: "",
    password: "",
    confirmPassword: "",
    talukId: "",
    phcId: "",
    ashaBlockId: "", 
  });

  const [showAlertModal, setShowAlertModal] = useState(false);
   const [modalData, setModalData] = useState({});

  const [error, setError] = useState({
    name: "",
    email: "",
    mobileNo: "",
    role: "",
    designation: "",
    password: "",
    confirmPassword: "",
    talukId: "",
    phcId: "",
    ashaBlockId: "", 
  });

  const getRoles = async () => {
    try {
      fetchDropdownData()
      const res = await RolesService.getAllRoles(1, 1000, 1);
      setRoles(res.data?.length > 0 ? res.data : []);
    } catch {}
  };

  const getPhcs = async (talukId) => {
    try {
      const res = await PHCServices.gePhcsByTalukId(talukId);
      setPhcs(Array.isArray(res) ? res : []);
    } catch (err) {
      console.error("Error fetching PHCs:", err);
      setPhcs([]);
    }
  };

  const getAshaBlocks = async (phcId) => {
    if (!phcId) {
      setAshaBlocks([]);
      return;
    }
  
    try {
      const res = await AshaBlockServices.geAshaBlockByPhcId(phcId);
  
      if (Array.isArray(res)) {
        setAshaBlocks(res);
      } else {
        setAshaBlocks([]);
      }
    } catch (error) {
      console.error("Failed to fetch AshaBlocks for PHC", error);
      setAshaBlocks([]);
    }
  };
  

  const getDesignations = async (did) => {
    try {
      const res = await DesignationsService.geDesignationsById(did);
      if (res.data?.length > 0) {
        setDesignations(res.data);
      } else {
        setUsers({ ...users, designationId: null });
        setDesignations([]);
      }
    } catch {}
  };

  const getPasswordStrength = (password) => {
    if (!password) return "";
    let strength = 0;
    if (password.length >= 8) strength++;
    if (/[A-Z]/.test(password)) strength++;
    if (/[a-z]/.test(password)) strength++;
    if (/\d/.test(password)) strength++;
    if (/[@$!%*?&]/.test(password)) strength++;
    
    
    if (strength <= 2) return "Weak";
    if (strength === 3 || strength === 4) return "Medium";
    if (strength === 5) return "Strong";
    };


  const handleTalukChange = async (e) => {
    const value = e.target.value;
    setSelectedTaluk(value);
    setSelectedPhc('');
    setSelectedAshaBlock('');
    if (roles.find(r => r.id === users.roleId)?.role === "PHC" || roles.find(r => r.id === users.roleId)?.role === "Asha Block") {
      await getPhcs(value);
    }
  };

  const handlePhcChange = async (e) => {
    const value = e.target.value;
    setSelectedPhc(value);
    setSelectedAshaBlock("");
    if (roles.find(r => r.id === users.roleId)?.role === "Asha Block") {
      await getAshaBlocks(value);
    }
  };
  
  
  const fetchDropdownData = async () => {
    try {
      const [taluksResponse] = await Promise.all([
        TalukServices.getAllTaluks(),
      ]);
      setTaluks(Array.isArray(taluksResponse) ? taluksResponse : []);
    } catch (err) {
      console.error("Error fetching dropdown data:", err);
      setShowAlertModal(true);
    }
  };

  const validation = () => {
    let tempError = { 
      name: "", 
      email: "", 
      mobileNo: "", 
      role: "", 
      designation: "", 
      password: "", 
      confirmPassword: "", 
      taluk: "", 
      phc: "", 
      ashaBlock: "" 
    };
    let valid = true;
  
    if (!users.name) { 
      tempError.name = "Name is required"; 
      valid = false; 
    }
    if (!users.mobileNo || !users.mobileNo.match(/^\d{10}$/)) { 
      tempError.mobileNo = "Mobile number must be 10 digits"; 
      valid = false; 
    }
    if (!users.email || !users.email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) { 
      tempError.email = "Invalid email"; 
      valid = false; 
    }
    if (!users.roleId) { 
      tempError.role = "Role is required"; 
      valid = false; 
    }
    if (!users.designationId) { 
      tempError.designation = "Designation is required"; 
      valid = false; 
    }
    if (!users.password || !users.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)) { 
      tempError.password = "Password must be 8+ chars with upper, lower, number & special char"; 
      valid = false; 
    }
    if (users.password !== confirmPassword) { 
      tempError.confirmPassword = "Passwords do not match"; 
      valid = false; 
    }
  
    // Role-based location validation
    if (users.roleId === 2 && !selectedTaluk) {
      tempError.taluk = "Taluk is required";
      valid = false;
    }
    if (users.roleId === 3) {
      if (!selectedTaluk) {
        tempError.taluk = "Taluk is required";
        valid = false;
      }
      if (!selectedPhc) {
        tempError.phc = "PHC is required";
        valid = false;
      }
    }
    if (users.roleId === 4) {
      if (!selectedTaluk) {
        tempError.taluk = "Taluk is required";
        valid = false;
      }
      if (!selectedPhc) {
        tempError.phc = "PHC is required";
        valid = false;
      }
      if (!selectedAshaBlock) {
        tempError.ashaBlock = "Asha Block is required";
        valid = false;
      }
    }
    setError(tempError);
    return valid;
  };
  

  const submitUsers = (e) => {
    e.preventDefault();
    if (validation()) addUsers();
  };

  const addUsers = async () => {
    setLoading(true);
    try {
      let payload = { ...users };
  
      // Attach taluk/phc/ashaBlock depending on role
      if (users.roleId === 2) {
        payload.talukId = selectedTaluk;
      } else if (users.roleId === 3) {
        payload.phcId = selectedPhc;
      } else if (users.roleId === 4) {
        payload.ashaBlockId = selectedAshaBlock;
      }
  
      const res = await UsersService.addUsers(payload);
      if (res.status === 200) {
        setModalData({
          title: 'Success',
          message: 'User added successfully!',
          variant: 'success'
        });
        setShowAlertModal(true);
        resetForm();
        props.onHide();
        navigate("/users");
      } else {
        setModalData({
          title: 'Error',
          message: 'Error While Addind User!',
          variant: 'danger'
        });
        setShowAlertModal(true);
      }
    } catch (error) {
      setModalData({
        title: 'Error',
        message: error.message || 'Failed to add user. Please try again.',
        variant: 'danger'
      });
      setShowAlertModal(true);
    } finally {
      setLoading(false);
    }
  };
  

  const resetForm = () => {
    setUsers({ name: "", email: "", mobileNo: "", roleId: "", designationId: "", password: "" });
    setConfirmPassword("");
    setSelectedTaluk("");
    setSelectedPhc("");
    setSelectedAshaBlock("");
    setPhcs([]);
    setAshaBlocks([]);
    };
  useEffect(() => { getRoles(); }, []);

  return (
    <>
      <Modal
        {...props}
        size="lg"
        centered
        backdrop={loading ? 'static' : true}
        keyboard={!loading}
        className={styles.modal}
        onExited={resetForm}
      >
        <Form onSubmit={submitUsers} className={styles.modalForm}>
          <Modal.Header closeButton={!loading} closeVariant={loading ? 'white' : undefined} className={styles.modalHeader}>
            <Modal.Title className={styles.modalTitle}>Add User</Modal.Title>
          </Modal.Header>

          <Modal.Body className={styles.modalBody}>
            {loading ? (
              <div className="text-center p-3">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Saving...</span>
                </Spinner>
                <p className="mt-2">Saving user details...</p>
              </div>
            ) : (
              <>
                {/* Base fields */}
                <Row className="mb-3">
                  <Col md={6}>
                    <FloatingLabel controlId="name" label="Name*">
                      <Form.Control type="text" value={users.name} onChange={(e) => setUsers({ ...users, name: e.target.value })} isInvalid={!!error.name} required />
                      <div className="invalid-feedback">{error.name}</div>
                    </FloatingLabel>
                  </Col>
                  <Col md={6}>
                    <FloatingLabel controlId="mobno" label="Mobile No">
                      <Form.Control type="text" maxLength={10} value={users.mobileNo} onChange={(e) => setUsers({ ...users, mobileNo: e.target.value.replace(/[^0-9]/g, '') })} isInvalid={!!error.mobileNo}/>
                      <div className="invalid-feedback">{error.mobileNo}</div>
                    </FloatingLabel>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <FloatingLabel controlId="email" label="Email*">
                      <Form.Control type="email" value={users.email} onChange={(e) => setUsers({ ...users, email: e.target.value })} isInvalid={!!error.email} required />
                      <div className="invalid-feedback">{error.email}</div>
                    </FloatingLabel>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={6}>
                    <FloatingLabel controlId="password" label="Password*">
                      <Form.Control type="password" value={users.password} onChange={(e) => setUsers({ ...users, password: e.target.value })} isInvalid={!!error.password} required />
                      <div className="invalid-feedback">{error.password}</div>
                    </FloatingLabel>
                    <small className="text-muted">Strength: {getPasswordStrength(users.password)}</small>
                  </Col>
                  <Col md={6}>
                    <FloatingLabel controlId="confirmPassword" label="Confirm Password*">
                      <Form.Control type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} isInvalid={!!error.confirmPassword} required />
                      <div className="invalid-feedback">{error.confirmPassword}</div>
                    </FloatingLabel>
                  </Col>
                </Row>

                {/* Role + Designation */}
                <Row className="mb-3">
                  <Col md={6}>
                    <FloatingLabel controlId="role" label="Role*">
                      <Form.Select value={users.roleId} onChange={(e) => { setUsers({ ...users, roleId: Number(e.target.value) }); getDesignations(Number(e.target.value)); }} isInvalid={!!error.role} required>
                        <option value="">Select Role</option>
                        {roles
      .filter((role) => role.role !== "Hospital")
      .map((role) => (
        <option key={role.id} value={role.id}>
          {role.role}
        </option>
      ))}
                      </Form.Select>
                      <div className="invalid-feedback">{error.role}</div>
                    </FloatingLabel>
                  </Col>
                  <Col md={6}>
                    <FloatingLabel controlId="designation" label="Designation*">
                      <Form.Select value={users.designationId} onChange={(e) => setUsers({ ...users, designationId: Number(e.target.value) })} isInvalid={!!error.designation} required>
                        <option value="">Select Designation</option>
                        {designations.map((d) => (<option key={d.id} value={d.id}>{d.designation}</option>))}
                      </Form.Select>
                      <div className="invalid-feedback">{error.designation}</div>
                    </FloatingLabel>
                  </Col>
                </Row>

                {/* Taluk only */}
                {roles.find(r => r.id === users.roleId)?.role === "Taluk" && (
                  <Row className="mb-3">
                    <Col md={6}>
                      <FloatingLabel controlId="taluk" label="Taluk*">
                        <Form.Select value={selectedTaluk} onChange={handleTalukChange} required>
                          <option value="" disabled hidden>Select Taluk</option>
                          {taluks.map((t) => (<option key={t.id} value={t.id}>{t.taluk}</option>))}
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                  </Row>
                )}

                {/* PHC: Taluk + PHC */}
                {roles.find(r => r.id === users.roleId)?.role === "PHC" && (
                  <Row className="mb-3">
                    <Col md={6}>
                      <FloatingLabel controlId="taluk" label="Taluk*">
                        <Form.Select value={selectedTaluk} onChange={handleTalukChange} required>
                          <option value="" disabled hidden>Select Taluk</option>
                          {taluks.map((t) => (<option key={t.id} value={t.id}>{t.taluk}</option>))}
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                    <Col md={6}>
                      <FloatingLabel controlId="phc" label="PHC*">
                        <Form.Select value={selectedPhc} onChange={handlePhcChange} required disabled={!selectedTaluk}>
                          <option value="" disabled hidden>Select PHC</option>
                          {phcs.map((p) => (<option key={p.id} value={p.id}>{p.phc}</option>))}
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                  </Row>
                )}

                {/* Asha Block: Taluk + PHC + Asha Block */}
                {roles.find(r => r.id === users.roleId)?.role === "Asha Block" && (
                  <Row className="mb-3">
                    <Col md={4}>
                      <FloatingLabel controlId="taluk" label="Taluk*">
                        <Form.Select value={selectedTaluk} onChange={handleTalukChange} required>
                          <option value="" disabled hidden>Select Taluk</option>
                          {taluks.map((t) => (<option key={t.id} value={t.id}>{t.taluk}</option>))}
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                    <Col md={4}>
                      <FloatingLabel controlId="phc" label="PHC*">
                        <Form.Select value={selectedPhc} onChange={handlePhcChange} required disabled={!selectedTaluk}>
                          <option value="" disabled hidden>Select PHC</option>
                          {phcs.map((p) => (<option key={p.id} value={p.id}>{p.phc}</option>))}
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                    <Col md={4}>
                      <FloatingLabel controlId="ashaBlock" label="Asha Block*">
                        <Form.Select value={selectedAshaBlock} onChange={(e) => setSelectedAshaBlock(e.target.value)} required disabled={!selectedPhc}>
                          <option value="" disabled hidden>Select Asha Block</option>
                          {ashaBlocks.map((a) => (<option key={a.id} value={a.id}>{a.ashaBlock}</option>))}
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                  </Row>
                )}
              </>
            )}
          </Modal.Body>

          <Modal.Footer className={styles.modalFooter}>
            <Button type="submit" variant="success" disabled={loading} className={buttonStyles.primaryButton}>
              {loading ? 'Saving...' : 'Save User'}
            </Button>
            <Button variant="danger" onClick={props.onHide} disabled={loading} className={buttonStyles.dangerButton}>
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

        {/* Alert Modal */}
        <AlertModal
          show={showAlertModal}
          onHide={() => setShowAlertModal(false)}
          title={modalData.title}
          message={modalData.message}
          variant={modalData.variant || 'info'}
        />
    </>
  );

}

export default AddUsers;
